<template>
  <div class="viewer3d">
    <model-fbx src="demofbx2.fbx"
        :controlsOptions="{
          enablePan,
          enableZoom,
          enableRotate,
        }"
>
    </model-fbx>
  </div>
</template>

<script>
// import router from "../router";
// import { bus } from "../main";
import { ModelFbx } from 'vue-3d-model';
// import axios from "axios";

export default {
  name: "Viewer3d",
  components: {ModelFbx},
  data() {
    return {
      locale: "",
      enablePan: true,
      enableZoom: true,
      enableRotate: true,
      cameraposition: {
        x: 0,
        y: 0,
        z: 0
      }
    };
  },
  methods: {

  },
  async mounted() {

  },
  updated: function() {},
  created() {
    // langCheck
    // console.log(this.$route.query.lang);
    // if (!this.$route.query.lang) {
    //   router.push({ query: { lang: "ro" } });
    //   this.locale = "ro";
    // } else {
    //   this.locale = this.$route.query.lang;
    //   this.fetchData();
    // }
    //
    // // lang switch
    // bus.$on("lang", data => {
    //   this.locale = data.lang;
    //   this.fetchData();
    // });
  },
  beforeCreate: function() {
    document.body.className = "class-project-viewer3d";
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.mq);
  }
};
</script>

<style lang="scss">
@import "~@/assets/styles/_reset.scss";
@import "~@/assets/styles/_variables.scss";
@import "~@/assets/styles/_components.scss";
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600&display=swap");

html {
  scroll-behavior: smooth;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {

}

@media screen and (max-width: 760px) {

}
</style>
